<template>
  <div class="third guanLiApi">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">{{ apiName }}/管理API</span>
        </div>
        <div class="btn-right">
          <el-button @click="resetForm" class="btn-two" type="default"
            >重置</el-button
          >
          <el-button
            @click="commit"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
            >保存</el-button
          >
        </div>
      </div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="86px"
        @validate="validateValue"
        :show-message="false"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">接口访问信息</span>
              </div>
            </div>
            <div class="one-list">
              <!-- <el-form-item label="资讯栏目名称" prop="showName">
                <el-input
                  class="list-input"
                  :maxlength="8"
                  v-model.trim="ruleForm.showName"
                  placeholder="请输入"
                ></el-input>
                <span></span>
              </el-form-item> -->
              <div class="list-one-line">
                <el-form-item label="接口来源" prop="apiForm">
                  <el-radio-group
                    v-model="ruleForm.apiForm"
                    @change="changeApiForm"
                  >
                    <el-radio label="1">数据总线</el-radio>
                    <el-radio label="2">服务总线</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div class="list-one-line-list">
                  <el-form-item label="接口" prop="api">
                    <key-value-select-2
                      style="display: inline-block"
                      :className="'list-input'"
                      v-model="ruleForm.api"
                      placeholder="请先输入接口中文名称再选择"
                      :autoSearch="true"
                      :apiForm="ruleForm.apiForm"
                      :selectedID="id"
                      ref="valueSelect"
                      :dictProp="{
                        data: 'result.data',
                        label: 'note',
                        value: 'id',
                      }"
                      :openSearch="true"
                      :isNeedCash="false"
                      @clearInfo="clearInfo"
                      @goReset="goReset"
                      @SelectLabel="
                        (value) => {
                          ruleForm.api = value;
                        }
                      "
                      @changeInfoData="changeInfoData"
                      :dictUrl="
                        ruleForm.apiForm == 1
                          ? '/api/blade-workbench/eduApiServeData/list'
                          : '/api/blade-workbench/eduApiServe/list'
                      "
                    ></key-value-select-2>
                    <span
                      v-if="isVB"
                      style="font-size: 10px; margin-left: 10px; color: #ff4d4f"
                      >若切换接口，已配置接口信息都将清空</span
                    >
                    <!-- <key-value-select
                    style="display:inline-block"
                    :className="'list-input'"
                    v-model="ruleForm.api"
                    placeholder="请输入姓名后选择"
                    :autoSearch="true"
                    :dictProp="{
                      data: 'result.data',
                      label: 'note',
                      value: 'name',
                    }"
                    :value="ruleForm.api"
                    :openSearch="true"
                    :isNeedCash="false"
                    @changeValue="(value)=> {
                      ruleForm.api = value
                    }"
                    @changeInfoData="(value)=> {
                      ruleForm.infoData = value
                    }"
                    dictUrl="/api/blade-workbench/eduApiServe/list"
                  ></key-value-select> -->
                  </el-form-item>
                </div>

                <el-form-item
                  label="访问参数"
                  prop="canShu"
                  :rules="{
                    required: true,
                    message: `请选择刷新时间`,
                    trigger: 'change',
                  }"
                >
                  <div
                    style="
                      font-size: 12px;
                      color: rgba(174, 174, 180, 0.847058823529412);
                    "
                  >
                    <span
                      :style="{ visibility: isVB ? 'hidden' : 'visible' }"
                      >{{ requstRemark }}</span
                    >
                  </div>
                  <div
                    v-for="(reply, indexss) in ruleForm.requestParamList"
                    :key="indexss"
                  >
                    <div>
                      <div
                        style="
                          display: inline-block;
                          vertical-align: top;
                          width: 305px;
                        "
                      >
                        <span>参数名称</span>
                        <span
                          style="
                            color: rgba(174, 174, 180, 0.847058823529412);
                            padding-left: 10px;
                          "
                          >{{ reply.name }}<span>({{ reply.note }})</span></span
                        >
                      </div>
                      <div
                        v-if="reply.name == 'pageSize'"
                        style="
                          display: inline-block;
                          vertical-align: top;
                          width: 316px;
                        "
                      >
                        <el-form-item label="每页数据值">
                          <el-input
                            class="list-input"
                            disabled
                            :maxlength="8"
                            v-model.trim="ruleForm.shujuzhi"
                          ></el-input>
                        </el-form-item>
                      </div>
                      <div
                        v-else
                        style="
                          display: inline-block;
                          vertical-align: top;
                          width: 396px;
                        "
                      >
                        <el-form-item
                          label="参数映射值"
                          :prop="`requestParamList.${indexss}.showValue`"
                          :rules="{
                            required: true,
                            message: `请选择${reply.name}参数映射值`,
                            trigger: 'change',
                          }"
                        >
                          <el-select
                            v-model="reply.showValue"
                            class="list-input"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="(item, index) in options2"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div
                        v-if="reply.showValue === 'CUSTOM'"
                        style="
                          display: inline-block;
                          vertical-align: top;
                          width: 316px;
                        "
                      >
                        <el-form-item
                          label="自定义值"
                          v-if="reply.showValue === 'CUSTOM'"
                          :prop="'requestParamList.' + indexss + '.customValue'"
                          :rules="{
                            required: true,
                            message: '请输入自定义值',
                            trigger: 'blur',
                          }"
                        >
                          <el-input
                            class="list-input"
                            :maxlength="60"
                            v-model.trim="reply.customValue"
                            placeholder="请输入"
                          ></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="每页数据量"
                        v-if="reply.showValue === 'PAGE_INDEX'"
                        :prop="'requestParamList.' + indexss + '.customValue'"
                        :rules="{
                          required: true, message: `请输入每页数据量`, trigger: 'blur'
                        }">
                        <el-input-number style="width: 216px !important;" class="list-input modelConfig-inputerNumber" v-model="reply.customValue" :min="1" :max="40" step-strictly placeholder="请输入1-40的正整数" :controls="false"></el-input-number>
                      </el-form-item> -->
                      </div>
                    </div>
                  </div>
                  <!-- <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    font-size: 12px;
                    width: 700px;
                  "
                  v-if="isVB"
                >
                  <div></div>
                  <div>
                    <el-form-item label="每页数据值">
                      <el-input
                        class="list-inputs"
                        disabled
                        :maxlength="8"
                        v-model.trim="ruleForm.shujuzhi"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div> -->
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content"
                  >资讯内容展示值字段映射<span
                    style="
                      font-weight: normal;
                      font-size: 12px;
                      color: rgba(174, 174, 180, 0.847058823529412);
                    "
                    >（请配置接口访问信息后选择值字段）</span
                  ></span
                >
              </div>
            </div>
            <div class="one-list">
              <!-- <el-form :model="ruleForm" :rules="rules" label-width="86px"> -->
              <div class="list-one-line">
                <el-form-item
                  label="标题"
                  prop="headline"
                  :rules="{
                    required: true,
                    message: `请输入标题`,
                    trigger: 'blur',
                  }"
                >
                  <el-select
                    v-model="ruleForm.headline"
                    class="list-input"
                    placeholder="请选择"
                    @click.native="ownerCompanyClick(ruleForm.headline)"
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      v-show="item.isShow"
                    >
                    </el-option>
                  </el-select>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="标题最大长度限制为255字符"
                    placement="top"
                  >
                     <i class="sp icontishishuoming" style="padding-left:5px;font-size:12px"></i>
                  </el-tooltip>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item label="内容">
                  <el-select
                    v-model="ruleForm.content"
                    class="list-input"
                    placeholder="请选择"
                    @click.native="ownerCompanyClick(ruleForm.content)"
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.label"
                      v-show="item.isShow"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="内容最大长度限制为10000字符"
                    placement="top"
                  >
                     <i class="sp icontishishuoming" style="padding-left:5px;font-size:12px"></i>
                  </el-tooltip>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item label="详情链接">
                  <el-select
                    v-model="ruleForm.JumpSite"
                    class="list-input"
                    placeholder="请选择"
                    @click.native="ownerCompanyClick(ruleForm.JumpSite)"
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      v-show="item.isShow"
                    >
                    </el-option>
                  </el-select>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="详情链接最大长度限制为255字符"
                    placement="top"
                  >
                     <i class="sp icontishishuoming" style="padding-left:5px;font-size:12px"></i>
                  </el-tooltip>
                </el-form-item>
              </div>
            </div>
            <div class="one-list">
              <!-- <el-form :model="ruleForm" :rules="rules" label-width="86px"> -->
              <div class="list-one-line">
                <el-form-item
                  label="发布时间"
                  prop="releaseTime"
                  :rules="{
                    required: true,
                    message: `请输入发布时间`,
                    trigger: 'blur',
                  }"
                >
                  <el-select
                    v-model="ruleForm.releaseTime"
                    class="list-input"
                    placeholder="请选择"
                    @click.native="ownerCompanyClick(ruleForm.releaseTime)"
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      v-show="item.isShow"
                    >
                    </el-option>
                  </el-select>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="发布时间最大长度限制为32字符"
                    placement="top"
                  >
                     <i class="sp icontishishuoming" style="padding-left:5px;font-size:12px"></i>
                  </el-tooltip>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item
                  label="发布人"
                  prop="issuer"
                  :rules="{
                    required: true,
                    message: `请输入发布人`,
                    trigger: 'blur',
                  }"
                >
                  <el-select
                    v-model="ruleForm.issuer"
                    class="list-input"
                    placeholder="请选择"
                    @click.native="ownerCompanyClick(ruleForm.issuer)"
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      v-show="item.isShow"
                    >
                    </el-option>
                  </el-select>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="发布人最大长度限制为32字符"
                    placement="top"
                  >
                     <i class="sp icontishishuoming" style="padding-left:5px;font-size:12px"></i>
                  </el-tooltip>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item label="图片">
                  <el-select
                    v-model="ruleForm.picture"
                    class="list-input"
                    placeholder="请选择"
                    @click.native="ownerCompanyClick(ruleForm.picture)"
                  >
                    <el-option
                      v-for="(item, index) in options"
                      v-show="item.isShow"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="图片最大长度限制为1000字符"
                    placement="top"
                  >
                     <i class="sp icontishishuoming" style="padding-left:5px;font-size:12px"></i>
                  </el-tooltip>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content"
                  >资讯时效性配置
                  <!-- <span
                    style="
                      font-weight: normal;
                      font-size: 12px;
                      color: rgba(174, 174, 180, 0.847058823529412);
                    "
                    >（请配置接口访问信息后选择值字段）</span
                  > -->
                  </span
                >
              </div>
            </div>
             <div class="one-list">
              <div class="list-one-line">
                <el-form-item
                  label="自动同步时间"
                  prop="synTime"
                  :rules="{
                    required: true,
                    message: `请输入自动同步时间`,
                    trigger: 'blur',
                  }"
                >
                  <el-time-select
                    class="list-input baseData-input-number"
                    v-model="ruleForm.synTime"
                    :picker-options="{
                      start: '00:00',
                      step: '01:00',
                      end: '24:59',
                    }"
                    placeholder="请选择每日同步时间"
                  >
                  </el-time-select>
                </el-form-item>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item
                  label="本地保留最近"
                  prop="lastKeepRecentDays"
                  :rules="{
                    required: true,
                    message: `请输入本地保留时间`,
                    trigger: 'blur',
                  }"
                >
                  <el-input-number
                    class="list-input baseData-input-number"
                    :controls="false"
                    v-model="ruleForm.lastKeepRecentDays"
                    :min="10"
                    :max="730"
                    step-strictly
                    placeholder="请输入10-730的正整数"
                  ></el-input-number
                  ><span
                    style="font-size: 12px; color: #2e4057; margin-left: 3px"
                    >天内的资讯</span
                  >
                  <div style="font-size:12px;color: #76838f">超出天数的资讯将会在每次同步后自动删除，天数以发布时间为准，发布时间格式请按照 年-月-日的标准格式，例如 2021.10.10</div>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      @agreeNoticeTwo="agreeNoticeTwo"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :isError="isError"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :btnAgreeTwo="agreeContentTwo"
      :noticeContent="noitceContent"
    ></notice-modal>
  </div>
</template>

<script>
import {
  detail,
  detailTwo,
  getParamTypeList,
  saveConfig,
  getApiFieldMapping,
} from "@/store/appconfig/inforMationConfig"; //我的;
import Sortable from "sortablejs";
// import addOfficalAccounts from '../component/addOfficalAccounts'
import { uniqBy, cloneDeep } from "lodash";
import { getStore } from "@/utils/store";
import { mapState } from "vuex";
import KeyValueSelect2 from "../../../components/key-value/key-value-select2.vue";
export default {
  name: "formSeven",
  props: ["rowId"],
  data() {
    return {

      isError: true, // 是否是错误提示
      //===========================================1.3.2更新
      apiName: "",
      requstRemark: "请选择接口",
      currentName: "",
      countNum: 1, //用于显示第一个错误
      addModalVisible: false,
      cpRowId: this.rowId,
      //   &********弹框******************************
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      agreeContentTwo: "", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定启用删除吗？", // 提示信息
      noticeModal: false, // 提示弹窗
      noticeSpec: "", // 标红提示
      //   &**************************************
      ruleForm: {
        apiForm: "1",
        api: "",
        canShu: true,
        canShuYS: "",
        syncOne: {
          seconds: "",
          date: "",
        },
        infoData: {},
        shujuzhi: 15,
        picture: "", //字段映射---图片
        issuer: "", //字段映射---发布人
        releaseTime: "", //字段映射---发布时间
        JumpSite: "", //字段映射---详情链接
        content: "", //字段映射---内容
        headline: "", //字段映射---标题
        requestParamList: [], // 请求参数列表
        synTime: "", //同步时间
        lastKeepRecentDays: undefined, //保存天数
      },
      otherForm: {
        projectName: "", // 所属来源
        serveData: "", // 基本信息
        serveProtocol: "", // 协议
        requestParamList: [], // 请求参数列表
        returnParamList: [], // 返回参数列表
        revisionList: [], // 修订记录列表
      },
      rules: {
        showName: [
          { required: true, message: "请输入展示名称", trigger: "blur" },
        ],
        apiForm: [
          { required: true, message: "请输入接口来源", trigger: "change" },
        ],
        canShuYS: [
          { required: true, message: "请输入参数映射值", trigger: "change" },
        ],
        api: [{ required: true, message: "请选择接口", trigger: "blur" }],
      },
      currentTableData: [],
      roleTags: [], // 角色标签
      roleTreeDialogVisible: false, // role弹窗
      roleTree: [],
      talNname: "新增",
      options: [],
      ownerCompanyOpts: [], // 货权主体下拉列表渲染数据
      ownerCompanyInitData: [], // 货权主体下拉列表初始数据
      existIds: [], // 货权主体下拉已添加选项的id
      options2: [],
      value: "",
      id: "",
      Rowid: "",
      selectedID: "",
    };
  },
  components: {
    KeyValueSelect2,
    // addOfficalAccounts
  },
  created() {
    let result = getStore({ name: "managementAPI", type: "session" });
    console.log(result);
    this.Rowid = result.id;
    this.apiName = result.name;
    this.ruleForm.lastKeepRecentDays = result.lastKeepRecentDays || 180
    this.ruleForm.synTime = result.synTime || "03:00"
    if (result.apiServeDataId && result.sourceType != "API") {
      //apiServeDataId即发起列表的接口id,sourceType:为接口类型
      this.id = result.apiServeDataId;
      this.selectedID = result.apiServeDataId;
      this.ruleForm.apiForm = result.sourceType == "SERVICE_API" ? "2" : "1";
      Promise.all([this.itemDetail(), this.getParamTypeList()]).then((res) => {
        this.getApiFieldMapping();
      });
    } else {
      this.getParamTypeList();
    }
  },
  mounted() {},
  watch: {
    rowId() {
      this.cpRowId = this.rowId;
    },
    // currentTableData() {
    //   this.$nextTick(() => {
    //     this.rowDrop()
    //   })
    // }
  },
  computed: {
    isVB: function () {
      //这里的this指向的是当前的vue实例
      if (
        this.ruleForm.requestParamList &&
        this.ruleForm.requestParamList.length > 0
      ) {
        return true;
      } else {
        return false;
      }
      // return this.ruleForm.requestParamList.length;  //如果这两的text是后台接受的数据，最好加个判断数据为不为空
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  methods: {
    // 确认弹窗
    agreeNotice() {
      this.updateData(1)
    },
    // 确认弹窗
    agreeNoticeTwo() {
      this.updateData(2)
    },
    //获取参数类型
    async getParamTypeList() {
      try {
        const {
          data: { result, msg, status },
        } = await getParamTypeList();
        if (status === 1000) {
          let arr = [];
          for (let key in result) {
            let js = {};
            js.label = key;
            js.value = result[key];
            arr.push(js);
          }
          this.options2 = arr;
          console.log(this.options2);
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    //获取api配置
    async getApiFieldMapping() {
      try {
        const {
          data: { result, msg, status },
        } = await getApiFieldMapping({ id: this.Rowid });
        if (status === 1000) {
          console.log(this.ruleForm.requestParamList, "此处初始化复制");
          result.forEach((item) => {
            if (item.paramType == "PARAM") {
              for (var i = 0; i < this.ruleForm.requestParamList.length; i++) {
                if (
                  this.ruleForm.requestParamList[i].name == item.originalField
                ) {
                  this.ruleForm.requestParamList[i].showValue = item.mapping;
                  this.ruleForm.requestParamList[i].customValue =
                    item.customValue;
                }
              }
              console.log(this.ruleForm.requestParamList, "复制完毕");
            } else if (
              item.paramType == "CONTENT" &&
              item.originalField == "title"
            ) {
              this.ruleForm.headline = item.mapping;
            } else if (
              item.paramType == "CONTENT" &&
              item.originalField == "publisher"
            ) {
              this.ruleForm.issuer = item.mapping;
            } else if (
              item.paramType == "CONTENT" &&
              item.originalField == "publishDate"
            ) {
              this.ruleForm.releaseTime = item.mapping;
            } else if (
              item.paramType == "CONTENT" &&
              item.originalField == "url"
            ) {
              this.ruleForm.JumpSite = item.mapping;
            } else if (
              item.paramType == "CONTENT" &&
              item.originalField == "content"
            ) {
              this.ruleForm.content = item.mapping;
            } else if (
              item.paramType == "CONTENT" &&
              item.originalField == "img"
            ) {
              this.ruleForm.picture = item.mapping;
            }
          });
          console.log(result, "初始化获取api设置");
          // this.ruleForm.apiForm = result[0].newsSectionId;
          this.go();
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    ownerCompanyClick(rowID) {
      this.go(); // 先调用之前的方法
      // 将当前选项加入到选项列表
      this.options.forEach((item) => {
        if (item.value == rowID) {
          item.isShow = true;
        }
      });
    },
    go() {
      //   console.log(item);
      let arrr = [];
      if (this.ruleForm.headline) {
        arrr.push(this.ruleForm.headline);
      }
      if (this.ruleForm.content) {
        arrr.push(this.ruleForm.content);
      }
      if (this.ruleForm.JumpSite) {
        arrr.push(this.ruleForm.JumpSite);
      }
      if (this.ruleForm.releaseTime) {
        arrr.push(this.ruleForm.releaseTime);
      }
      if (this.ruleForm.issuer) {
        arrr.push(this.ruleForm.issuer);
      }
      if (this.ruleForm.picture) {
        arrr.push(this.ruleForm.picture);
      }
      console.log(arrr);

      this.options.forEach((item) => {
        item.isShow = true;
      });
      console.log(this.options, "马上开始改变值了");
      //   let arr = [];
      for (var i = 0; i < arrr.length; i++) {
        this.options.forEach((item2) => {
          //   arr = [];
          if (item2.value === arrr[i]) {
            item2.isShow = false;
          }
        });
      }
      //   console.log(arr);
      //   this.options = arr;
      // 货权主体下拉已选的id
    },
    changeInfoData(aaa) {
      console.log(aaa, "选中的接口详情");
      if (aaa.id == this.selectedID) {
        this.resetForm();
        return;
      }
      this.id = aaa.id;
      this.itemDetail();
    },
    async itemDetail() {
      try {
        if (this.ruleForm.apiForm == "2") {
          const {
            data: { result, msg, status },
          } = await detail({
            id: this.id, // api的id
            tenantId: this.userInfo.tenant_id, // 租户id
            // tenantId: "10", // 调试时接口
            hostUrl: window.location.origin + "/", // 前端获取当前页面host
          });
          if (status === 1000) {
            const parmList = cloneDeep(result.requestParamList);
            //   this.ruleForm.api=result.apiServeData.note
            console.log(result.serveData.note);
            this.ruleForm.api = `${result.serveData.note}(${result.serveData.name})`;
            // debugger
            if (parmList) {
              if (parmList.length < 1) {
                this.requstRemark = "暂无数据";
              }
              const arr2 = [];
              parmList.forEach((element) => {
                if (element.name !== "appKey" && element.name !== "isAll") {
                  let obj = {
                    ...element,
                    showValue: "",
                    value: "",
                    customValue: "",
                  };
                  arr2.push(cloneDeep(obj));
                  // this.ruleForm.requestParamList.push(cloneDeep(obj));
                }
              });
              this.ruleForm.requestParamList = arr2;
            } else {
              this.requstRemark = "暂无数据";
            }

            const retureList = cloneDeep(result.returnParamList);
            if (retureList) {
              const arr = [];
              retureList.forEach((element) => {
                const js = {};
                js.label = `${element.name}(${element.note})`;
                js.value = `${element.name}`;
                js.isShow = true;
                arr.push(js);
              });
              this.options = arr;
              console.log("结果", this.otherForm);
              return;
            } else {
              this.options = [];
              return;
            }
          }
          return this.$message.error(msg);
        } else {
          const {
            data: { result, msg, status },
          } = await detailTwo({
            id: this.id, // api的id
            tenantId: this.userInfo.tenant_id, // 租户id
            // tenantId: "10", // 调试事解开
            hostUrl: window.location.origin + "/", // 前端获取当前页面host
          });
          if (status === 1000) {
            // this.ruleForm.api=result.apiServeData.note
            // debugger
            console.log(result.apiDataInfo.apiServeData.note);
            //   this.ruleForm.api = result.apiDataInfo.apiServeData.note;
            this.ruleForm.api = `${result.apiDataInfo.apiServeData.note}(${result.apiDataInfo.apiServeData.name})`;
            const parmList = cloneDeep(
              result.apiDataInfo.apiServeDataRequestParamList
            );
            if (parmList) {
              if (parmList.length < 1) {
                this.requstRemark = "暂无数据";
              }
              const arr2 = [];
              parmList.forEach((element) => {
                if (element.name !== "appKey" && element.name !== "isAll") {
                  let obj = {
                    ...element,
                    showValue: "",
                    value: "",
                    customValue: "",
                  };
                  arr2.push(cloneDeep(obj));
                  // this.ruleForm.requestParamList.push(cloneDeep(obj));
                }
              });
              this.ruleForm.requestParamList = arr2;
            } else {
              this.requstRemark = "暂无数据";
            }
            const retureList = cloneDeep(
              result.apiDataInfo.apiServeDataReturnParamList
            );
            if (retureList) {
              const arr = [];
              retureList.forEach((element) => {
                const js = {};
                js.label = `${element.name}(${element.note})`;
                js.value = `${element.name}`;
                js.isShow = true;
                arr.push(js);
              });
              this.options = arr;
            } else {
              this.options = [];
            }
            console.log("结果1111", this.ruleForm.requestParamList);
            return;
          }
          return this.$message.error(msg);
        }
      } catch (err) {
        console.log(err);
      }
    },
    changeApiForm() {
      this.$refs.valueSelect.clearData();
      this.ruleForm.requestParamList = [];
      this.requstRemark = "请选择接口";
      this.options = [];
      this.ruleForm.picture = "";
      this.ruleForm.issuer = "";
      this.ruleForm.releaseTime = "";
      this.ruleForm.JumpSite = "";
      this.ruleForm.content = "";
      this.ruleForm.headline = "";
      //   console.log(vaule);
    },
    clearInfo() {
      this.ruleForm.requestParamList = [];
      this.requstRemark = "请选择接口";
      this.options = [];
      this.ruleForm.picture = "";
      this.ruleForm.issuer = "";
      this.ruleForm.releaseTime = "";
      this.ruleForm.JumpSite = "";
      this.ruleForm.content = "";
      this.ruleForm.headline = "";
    },
    getRolelist() {
      let childrenList = []; // 整理角色列表 去除一级 只留二级数据
      this.roleTags = [];
      this.roleTree.forEach((element) => {
        element.children.forEach((ele) => {
          childrenList.push(ele);
        });
      });
      this.rowData.role_id.split(",").forEach((element) => {
        let role = childrenList.map((item) => {
          if (item.roleId === element) {
            return {
              id: item.roleId,
              name: item.roleName,
            };
          }
        });
        role = role.filter((item) => item);
        role.forEach((ele) => this.roleTags.push(ele));
      });
    },
    handleRoleClose(tag) {
      console.log(tag);
      const { roleTags } = this;
      this.roleTags = roleTags.filter((item) => item !== tag);
    },
    addTags(type) {
      this.roleTreeDialogVisible = true;
      this.roleOrlabel = true;
      if (this.roleTags.length > 0) {
        const keys = this.roleTags.map((item) => item.id);
        // console.log(keys)
        this.$nextTick(() => {
          this.$refs.roleTree.setCheckedKeys(keys);
        });
      }
    },
    getCheckedKeys(refName) {
      const getNode = this.$refs[refName].getCheckedNodes();
      if (this.roleOrlabel) {
        const selectArr = getNode.map((item) => {
          if (item.roleId) {
            return {
              name: item.roleName,
              id: item.roleId,
            };
          }
        });
        this.roleTags = selectArr.filter((item) => item);
        this.roleTreeDialogVisible = false;
      }
    },
    //返回首页
    goBack() {
      this.$emit("fatherMethod", "adhibitionJPG");
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate((valid) => {
          console.log("valid", valid);
          if (valid) {
            if (!this.ruleForm.JumpSite && !this.ruleForm.content) {
                this.$message.error('内容和详情链接字段至少选择一个')
                return
            }
            this.countNum = 1;
            // this.updateData();
            this.noticeSpec = ""; // 标红提示
            (this.noticeType = 1), // 提示类型
              (this.agreeContent = "保存"); // 提示弹窗确认按钮内容
            this.agreeContentTwo = "保存并立即同步"; // 提示弹窗确认按钮内容a2
            this.noticeTitle = "提示"; // 提示
            this.noitceContent =
              "请选择保存方式，若选择【保存并立即同步】资讯到本地，请在10分钟后，前往用户端查看具体资讯"; // 提示信息
            //   this.handSynId = row.id;
            //   this.deleteType = 5;
            this.noticeModal = true;
          } else {
            return false;
          }
        });
      });
    },
    goReset() {
      this.resetForm();
    },
    //表单重置
    resetForm() {
      //   this.$refs.ruleForm.clearValidate();
      //   //   this.ruleForm.apiForm = "1";
      //   this.changeApiForm();
      //   Promise.all([this.itemDetail(), this.getParamTypeList()]).then((res) => {
      //     this.getApiFieldMapping();
      //   });
      let result = getStore({ name: "managementAPI", type: "session" });
      console.log(result);
      this.Rowid = result.id;
      if (result.apiServeDataId && result.sourceType != "API") {
        this.id = result.apiServeDataId;
        this.ruleForm.apiForm = result.sourceType == "SERVICE_API" ? "2" : "1";
        Promise.all([this.itemDetail(), this.getParamTypeList()]).then(
          (res) => {
            this.getApiFieldMapping();
          }
        );
      } else {
        this.$refs.ruleForm.clearValidate();
        //   this.ruleForm.apiForm = "1";
        this.changeApiForm();
        this.getParamTypeList();
      }
    },
    async updateData(type) {
      console.log("this.cpRowId", this.ruleForm);
      try {
        const fieldMappingList = [];
        //   const newArr = this.ruleForm.requestParamList.filter((item) => {
        //     return item.name !== "pageSize";
        //   });
        const newArr = cloneDeep(this.ruleForm.requestParamList);
        newArr.forEach((item) => {
          let js2 = {};
          if (item.name == "pageSize") {
            js2.newsSectionId = this.Rowid;
            js2.originalField = item.name;
            js2.mapping = "PAGE_SIZE";
            js2.paramType = "PARAM";
            fieldMappingList.push(js2);
          } else {
            js2.newsSectionId = this.Rowid;
            js2.originalField = item.name;
            js2.mapping = item.showValue;
            js2.paramType = "PARAM";
            js2.custom_value = item.customValue;
            fieldMappingList.push(js2);
          }
        });
        //  picture: "", //字段映射---图片
        // issuer: "", //字段映射---发布人
        // releaseTime: "", //字段映射---发布时间
        // JumpSite: "", //字段映射---详情链接
        // content: "", //字段映射---内容
        // headline: "", //字段映射---标题
        fieldMappingList.push({
          newsSectionId: this.Rowid,
          originalField: "title",
          mapping: this.ruleForm.headline,
          paramType: "CONTENT",
        });
        fieldMappingList.push({
          newsSectionId: this.Rowid,
          originalField: "content",
          mapping: this.ruleForm.content,
          paramType: "CONTENT",
        });
        fieldMappingList.push({
          newsSectionId: this.Rowid,
          originalField: "url",
          mapping: this.ruleForm.JumpSite,
          paramType: "CONTENT",
        });
        fieldMappingList.push({
          newsSectionId: this.Rowid,
          originalField: "publishDate",
          mapping: this.ruleForm.releaseTime,
          paramType: "CONTENT",
        });
        fieldMappingList.push({
          newsSectionId: this.Rowid,
          originalField: "publisher",
          mapping: this.ruleForm.issuer,
          paramType: "CONTENT",
        });
        fieldMappingList.push({
          newsSectionId: this.Rowid,
          originalField: "img",
          mapping: this.ruleForm.picture,
          paramType: "CONTENT",
        });
        // console.log(js)
        const {
          data: { result, msg, status },
        } = await saveConfig({
          newsSectionId: this.Rowid,
          appDataId: this.id,
          fieldMappingList: fieldMappingList,
          sourceType: this.ruleForm.apiForm == "1" ? "DATA_API" : "SERVICE_API",
          synTime:this.ruleForm.synTime,
          type:type,
          lastKeepRecentDays:this.ruleForm.lastKeepRecentDays
        });
         this.noticeModal = false;
        if (status === 1000) {
          this.$message.success("操作成功");
          this.goBack();
          this.changeApiForm();
          console.log("结果", result);
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    deleteRowConfirm(rowData, index) {
      // this.agreeNotice = () => {
      //   this.noticeModal = false
      //   this.deleteRow(index)
      // }
      // this.noticeModal = true
      this.deleteRow(index);
    },
    deleteRow(index) {
      this.currentTableData.splice(index, 1);
    },
    updateStatus(rowData, index) {
      if (rowData.openStatus === "1") {
        this.$set(this.currentTableData[index], "openStatus", "2");
        return;
      }
      this.$set(this.currentTableData[index], "openStatus", "1");
    },
    addData(list) {
      console.log(list);
      // this.currentTableData = uniqBy([...this.currentTableData,...list],'serviceId')
      const oldList = [...this.currentTableData];
      const resolveData = [];
      const temporaryOldList = [];
      list.forEach((newData, index) => {
        const isHaveData = oldList.find((oldData) => {
          return oldData.serviceId === newData.serviceId;
        });
        if (isHaveData !== undefined) {
          console.log("isHaveData", isHaveData);
          temporaryOldList.push(isHaveData);
        } else {
          resolveData.push(newData);
        }
      });
      resolveData.reverse();
      console.log("resolveData", resolveData);
      this.currentTableData = [...resolveData, ...temporaryOldList];
      this.closeAddModal();
    },
    closeAddModal() {
      this.addModalVisible = false;
    },
    openAddDialog() {
      this.addModalVisible = true;
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.currentTableData.splice(oldIndex, 1)[0];
          _this.currentTableData.splice(newIndex, 0, currRow);
          const newList = [..._this.currentTableData];
          _this.currentTableData = [];
          _this.$nextTick(() => {
            _this.currentTableData = [...newList];
          });
          console.log("_this.currentTableData", _this.currentTableData);
        },
      });
    },
    // async itemDetail() {
    //   console.log("this.cpRowId", this.cpRowId);
    //   const {
    //     data: { result, msg, status },
    //   } = await itemDetailPort({
    //     id: this.rowId,
    //   });
    //   if (status === 1000) {
    //     this.currentName = result.itemName;
    //     this.ruleForm = result;
    //     this.currentTableData = [...result.serviceList];
    //     console.log("结果", result);
    //     return;
    //   }
    //   return this.$message.error(msg);
    // },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    // 复制地址
    copyUrl(url, params) {
      let copy = (e) => {
        e.preventDefault();
        e.clipboardData.setData("text/plain", url + params);
        this.$message.success("操作成功");
        document.removeEventListener("copy", copy);
      };
      document.addEventListener("copy", copy);
      document.execCommand("copy");
    },
    // 改变index页面的component的值
    changeComponent() {
      this.$emit("changeComponent", "homePage");
    },
  },
};
</script>
<style lang="scss">
.guanLiApi {
  .third-formOne .formOne-forms .forms-one .one-list .list-inputs {
    width: 178px;
  }
  .multi-rows,
  .single-row {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .add-row {
    margin-bottom: 15px;
    font-size: 12px;
    color: rgb(46, 63, 87);
    .el-button {
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
  .rows-copy {
    padding-left: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .single-row {
    min-width: 292px;
  }
  .row-goto {
    color: #2d8cf0;
    cursor: pointer;
  }
  .multi-rows {
    width: 676px;
  }
  .baseData-input-number {
    .el-input__inner {
      text-align: left;
    }
  }
}
</style>
